import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { OptOut } from './components/opt-out/opt-out';
import { Election } from './components/election/election';

export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'opt-out' },
  { path: 'opt-out', component: OptOut },
  { path: 'election', component: Election },
  { path: 'complete', component: Complete },
  { path: '**', redirectTo: 'opt-out' },

];
